<template>
  <section class="shareContent" v-show="showPopups">
    <div class="shareCanvas" ref="canvas">
      <canvas id="canvas"></canvas>
    </div>
    <div class="canvas-overlay" @click="cancel()"></div>
    <img src id="weChatImg" style="display: none" />
    <van-action-sheet
      cancel-text="取消"
      close-on-click-action
      v-model="showPopups"
      @cancel="cancel()"
      @click-overlay="cancel()"
      :overlay="false"
    >
      <div class="shareIcon">
        <div
          v-for="(item, index) in options"
          :key="index"
          @click="shareProduct(index)"
        >
          <img :src="item.icon" alt />
          <span>{{ item.name }}</span>
        </div>
      </div>
    </van-action-sheet>
    <van-overlay :show="showOverlay" class-name="share-overlay" z-index="9999">
      <div class="overlay-wrapper" @click.stop>
        <div class="overlay-block">
          <van-loading type="spinner" />
          <p>海报加载中...</p>
        </div>
      </div>
    </van-overlay>
  </section>
</template>

<script>
import { uploadImageBase64,drawWxShare } from "@/api/join";
export default {
  name: "sharePopup",
  props: {
    shareObj: Object,
    showPopup: {
      default: false,
      type: Boolean,
    },
  },
  data() {
    return {
      options: [
        {
          name: "微信",
          icon: require("../../assets/img/wx.png"),
        },
        {
          name: "朋友圈",
          icon: require("../../assets/img/pyq.png"),
        },
        {
          name: "保存图片",
          icon: require("../../assets/img/pic.png"),
        },
      ],
      imgUrl: "", //canvas生成的分享图
      showOverlay: true
    };
  },
  methods: {
    getCanvasImg() {
      let myCanvas = document.getElementById("canvas"),
        ctx = myCanvas.getContext("2d"),
        u = navigator.userAgent,
        that = this,
        ratio = that.getPixelRatio(ctx)
      myCanvas.style.width = myCanvas.offsetWidth + "px";
      myCanvas.style.height = myCanvas.offsetHeight + "px";
      myCanvas.width = myCanvas.offsetWidth * ratio;
      myCanvas.height = myCanvas.offsetHeight * ratio;
      // 缩放画布
      ctx.scale(ratio, ratio);
      // 清理画布
      ctx.clearRect(0, 0, myCanvas.clientWidth, myCanvas.clientHeight);
      // 绘制矩形并填充色
      that.roundRect(0, 0, that.xPxHandle(275), that.yPxHandle(342), 0, "#fff", ctx);
      // 超出画布的区域不展示
      ctx.clip();
      let baseURL = that.prefixURL || "http://192.168.1.58:8080/app";
      let scene = `${that.$store.getters.memberId},${that.$store.getters.communityShopId},-1${that.shareObj.isBoss? ",isBoss" : ""}`;
      // 利用img的src（get）请求获取流资源
      let wxQR = (document.getElementById(
        "weChatImg"
      ).src = `${baseURL}/comm/2_1/getWXQrcodeOfId?width=102&scene=${scene}&page=pages/rankingList/rankingList`);
      let img = new Image();
      img.setAttribute("crossOrigin", "Anonymous");
      img.src = that.prefixURL + 'mobile/img/mp/invite/yaoqinghaoyou_qietuh5.png';
      img.onload = function () {
        // 绘制背景图
        ctx.drawImage(
          img,
          0,
          0,
          that.xPxHandle(275),
          that.yPxHandle(342)
        );
        // 绘制头像
        let headpic = new Image();
        headpic.setAttribute("crossOrigin", "Anonymous");
        headpic.src = that.imgPrex + that.shareObj.headpic;
        headpic.onload = function () {
          that.roundRectPic(that.xPxHandle(121), that.yPxHandle(66), that.xPxHandle(34), that.yPxHandle(34), 2.5, "#fff", ctx, headpic);
        };
        headpic.onerror = function () {
          // 图片加载失败
          that.showOverlay = false;
        }
        // 绘制二维码
        let imgQR = new Image();
        imgQR.setAttribute("crossOrigin", "Anonymous");
        imgQR.src = wxQR;
        imgQR.onload = function () {
          ctx.drawImage(
            imgQR,
            that.xPxHandle(87),
            that.yPxHandle(172),
            that.xPxHandle(102),
            that.yPxHandle(102)
          );
          let strDataURI = myCanvas.toDataURL(0.1);
          that.getWeChatCodeImg(strDataURI.split(",")[1]);
        };
        imgQR.onerror = function () {
          // 图片加载失败
          that.showOverlay = false;
        }
        // 绘制用户名称
        ctx.textAlign = "center";
        ctx.font = "800 8px Arial";
        ctx.fillStyle = "#861A10";
        that.canvasWraptitleText(
          ctx,
          that.shareObj.name,
          that.xPxHandle(137),
          that.yPxHandle(120),
          that.xPxHandle(25),
          that.yPxHandle(20),
          1
        );
      };
      ctx.save();
    },
    // 获取分享图片链接
    getWeChatCodeImg(code) {
      uploadImageBase64({
        fileContent: code,
        //参数
      }).then((res) => {
        // OnSuccess function
        this.imgUrl = res.content.path;
        this.showOverlay = false;
      });
    },

    //处理canvas的x轴||width的px单位
    xPxHandle(pxs) {
      //不同分辨率下不同的宽度
      //pxs--原始单位
      let myCanvas = document.getElementById("canvas"),
        ctx = myCanvas.getContext("2d");
      return Math.round(
        ((myCanvas.width / this.getPixelRatio(ctx)) * pxs) / 275
      );
    },
    //处理canvas的y轴||height的px单位
    yPxHandle(pxs) {
      //不同分辨率下不同的宽度
      //pxs--原始单位
      let myCanvas = document.getElementById("canvas"),
        ctx = myCanvas.getContext("2d");
      return Math.round(
        ((myCanvas.height / this.getPixelRatio(ctx)) * pxs) / 342
      );
    },
    // 自适应绘制多行文字
    /**
     * @param {Object} ctx canvas上下文
     * @param {String} text 需要输入的文本
     * @param {Number} x X轴起始位置
     * @param {Number} y y轴起始位置
     * @param {Number} maxWidth 单行最大宽度
     * @param {Number} lineHeight 行高
     */
    drawText(ctx, text, x, y, maxWidth, lineHeight) {
      let canvas = ctx.canvas;
      let arrText = text.split("");
      let line = "";
      for (let n = 0; n < arrText.length; n++) {
        let testLine = line + arrText[n];
        let metrics = ctx.measureText(testLine);
        let testWidth = metrics.width;
        if (testWidth > maxWidth && n > 0) {
          ctx.fillText(line, x, y);
          line = arrText[n];
          y += lineHeight;
        } else {
          line = testLine;
        }
      }
      ctx.fillText(line, x, y);
    },

    // canvas画圆角矩形封装函数
    /**
     * @param {Object} x x轴坐标点
     * @param {String} y y轴坐标点
     * @param {Number} w 画布宽度
     * @param {Number} h 画布高度
     * @param {Number} r 圆角弧度
     * @param {Number} col 填充色
     * @param {Number} ctx 画布对象
     */
    roundRect(x, y, w, h, r, col, ctx) {
      if (w < 2 * r) r = w / 2;
      if (h < 2 * r) r = h / 2;
      ctx.beginPath();
      ctx.moveTo(x + r, y);
      ctx.arcTo(x + w, y, x + w, y + h, r);
      ctx.arcTo(x + w, y + h, x, y + h, r);
      ctx.arcTo(x, y + h, x, y, r);
      ctx.arcTo(x, y, x + w, y, r);
      ctx.fillStyle = col; //填充色
      ctx.fill();
      // ctx.strokeStyle = borcol; //边框色
      ctx.closePath();
    },
    roundRectPic(x, y, w, h, r, col, ctx, img) {
      ctx.save();
      if (w < 2 * r) r = w / 2;
      if (h < 2 * r) r = h / 2;
      ctx.beginPath();
      ctx.moveTo(x + r, y);
      ctx.arcTo(x + w, y, x + w, y + h, r);
      ctx.arcTo(x + w, y + h, x, y + h, r);
      ctx.arcTo(x, y + h, x, y, r);
      ctx.arcTo(x, y, x + w, y, r);
      ctx.closePath();
		  ctx.clip()
      ctx.drawImage(img, x, y, w, h)
      ctx.restore();
    },
    // canvas绘制文本超出显示省略号
    /**
     * @param {String} canvas 对象
     * @param {String} text 文本
     * @param {Object} x x轴坐标点
     * @param {String} y y轴坐标点
     * @param {Number} maxWidth 画布宽度
     * @param {Number} lineHeight 画布高度
     * @param {Number} maxRowNum 最大行数
     */
    canvasWraptitleText(canvas, text, x, y, maxWidth, lineHeight, maxRowNum) {
      if (typeof text != "string" || typeof x != "number" || typeof y != "number") {
        return;
      }
      // 字符分隔为数组
      var arrText = text.split("");
      var line = "";
      var rowNum = 1;
      for (var n = 0; n < arrText.length; n++) {
        var testLine = line + arrText[n];
        var metrics = canvas.measureText(testLine);
        var testWidth = metrics.width;
        if (testWidth > maxWidth && n > 0) {
          if (rowNum >= maxRowNum) {
            var arrLine = testLine.split("");
            arrLine.splice(-2);
            var newTestLine = arrLine.join("");
            newTestLine += "**";
            canvas.fillText(newTestLine, x, y);
            //如果需要在省略号后面添加其他的东西，就在这个位置写（列如添加扫码查看详情字样）
            //canvas.fillStyle = '#2259CA';
            //canvas.fillText('扫码查看详情',x + maxWidth-90, y);
            return;
          }
          canvas.fillText(line, x, y);
          line = arrText[n];
          y += lineHeight;
          rowNum += 1;
        } else {
          line = testLine;
        }
      }
      canvas.fillText(line, x, y);
    },
    getPixelRatio(context) {
      var backingStore =
        context.backingStorePixelRatio ||
        context.webkitBackingStorePixelRatio ||
        context.mozBackingStorePixelRatio ||
        context.msBackingStorePixelRatio ||
        context.oBackingStorePixelRatio ||
        context.backingStorePixelRatio ||
        1;
      return (window.devicePixelRatio || 1) / backingStore;
    },
    cancel() {
      this.$emit("hidePopup", false);
    },
    shareProduct(type) {
      if (this.imgUrl == "") {
        return;
      }
      let shareType = "4";
      let title = `这里有免费的${this.shareObj.title}，快来领！`;
      let imgUrl = type == 0 ? this.prefixURL + "mobile/img/mp/invite/paihangbang.png" : this.imgPrex + this.imgUrl;
      if (this.$store.getters.ambientType == 1) {
        // Android环境
        window.Android.shareCommunity(
          imgUrl,
          title,
          shareType,
          type,
          this.$store.getters.communityShopId,
          "-1"
        );
      } else if (this.$store.getters.ambientType == 2) {
      // ios环境
      /**
       * @param {} imgUrl 分享图路径
       * @param {} title 分享文本
       * @param {} shareType 分享类型 0-商品  1-店铺  2-邀请社区店长注册 3-邀请用户注册 4-排行榜
       * @param {} type  点击类型 0-微信分享 1-微信朋友圈  2-保存图片
       * @param {} communityShopId 店家id
       * @param {} sellerProductGoodsId 商品id
       */
      window.webkit.messageHandlers.shareCommunity.postMessage({
        imgUrl: imgUrl,
        title: title,
        shareType: shareType,
        type: type.toString(),
        communityShopId: this.$store.getters.communityShopId,
        sellerProductGoodsId: "-1",
      });
    }
  },
    // 获取微信小程序卡片分享的主图
    drawWxShare(spgId){
      drawWxShare({spgId}).then(res=>{
        if (res.appStatus.errorCode == 0) {
          this.shareGoodsPic = res.content.url
        }
      })
    }
  },
  computed: {
    showPopups: {
      get: function () {
        return this.showPopup;
      },
      set: function () {},
    },
  },
  watch: {
    showPopup: {
      handler(newV, oldV) {
        if (newV) {
          setTimeout(() => {
            this.getCanvasImg();
          }, 20);
          this.showOverlay = newV;
        }
      },
      immediate: true,
      deep: true,
    },
  },
};
</script>

<style lang="scss" scoped>
.shareContent {
  width: 100%;
  height: 100%;
  .shareCanvas {
    width: 275px;
    height: 342px;
    position: fixed;
    z-index: 2002;
    top: calc((50% - 120px) / 2);
    left: 0;
    right: 0;
    margin: 0 auto;
    padding: 10px;
    transform: translateY(calc((-50% + 200px) / 2));
    background-color: #FFFFFF;
    border-radius: 10px;
  }
  #canvas{
    width: 275px;
    height: 342px;
  }
  .canvas-overlay {
    width: 100%;
    height: 100%;
    background: #000;
    opacity: 0.5;
    position: fixed;
    top: 0;
    left: 0;
    z-index: 2001;
  }
  /deep/.van-action-sheet {
    border-radius: 0;
    .van-action-sheet__content {
      > p {
        color: #333;
        font-size: 12px;
        text-align: center;
        margin: 10px auto 0;
        span {
          color: #ff1310;
        }
        img{
          width: 345px;
          height: 28px;
          display: block;
          margin: 10px auto 0;
        }
      }
      .shareIcon {
        display: flex;
        justify-content: space-around;
        > div {
          display: flex;
          flex-flow: column;
          align-items: center;
          img {
            width: 61px;
            height: 61px;
          }
          span {
            font-size: 14px;
            color: #666;
          }
        }
      }
    }
    .van-action-sheet__gap {
      height: 1.04px;
    }
    .van-action-sheet__cancel {
      height: 49px;
    }
  }
  /deep/.van-loading__spinner {
    width: 32px;
    height: 32px;
  }
  .share-overlay{
    background: none;
    .overlay-wrapper {
      display: flex;
      align-items: center;
      justify-content: center;
      height: 100%;
      .overlay-block {
        width: 109px;
        height: 106px;
        display: flex;
        flex-direction: column;
        justify-content: center;
        align-items: center;
        background: #000000;
        opacity: 0.64;
        border-radius: 5px;
        p{
          margin-top: 15px;
          font-size: 12px;
          color: #FFFFFF;
        }
      }
    }
  }
}
</style>

